<script>
export default {
    name: 'Illu4x',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7'
        },

        secondaryColor: {
            type: String,
            default: '#313132'
        },
    }
}
</script>
<template>
    <svg
        class="base-illu illu-x"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <circle :stroke="secondaryColor" class="secondary-color" cx="22" cy="22" r="8.5" />
            <circle :stroke="secondaryColor" class="secondary-color" cx="42" cy="22" r="8.5" />
            <circle :stroke="secondaryColor" class="secondary-color" cx="22" cy="42" r="8.5" />
            <circle :stroke="secondaryColor" class="secondary-color" cx="42" cy="42" r="8.5" />
            <path
                d="M22 37a5 5 0 110 10 5 5 0 010-10zm20 0a5 5 0 110 10 5 5 0 010-10zM22 17a5 5 0 110 10 5 5 0 010-10zm20 0a5 5 0 110 10 5 5 0 010-10z"
                :fill="primaryColor" class="primary-color"
            />
        </g>
    </svg>
</template>
